import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeftIcon, EditIcon, MailIcon, PhoneIcon, MapPinIcon, PackageIcon, CalendarIcon, TrendingUpIcon } from 'lucide-react';
export function SupplierDetail() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  // Mock data
  const supplier = {
    id: id,
    companyName: 'Premium Tea Estates Ltd',
    contactPerson: 'Rajesh Kumar',
    email: 'rajesh@premiumtea.lk',
    phone: '+94 77 123 4567',
    address: '123 Tea Estate Road, Nuwara Eliya, Sri Lanka',
    productsSupplied: 'Ceylon Black Tea, Green Tea, White Tea',
    paymentTerms: 'Net 30',
    status: 'Active',
    totalOrders: 45,
    totalValue: 'LKR 2,450,000',
    lastOrderDate: '2024-01-15',
    createdDate: '2023-06-10'
  };
  const recentOrders = [{
    id: 'PO-001',
    date: '2024-01-15',
    items: 'Ceylon Black Tea (500kg)',
    amount: 'LKR 125,000',
    status: 'Delivered'
  }, {
    id: 'PO-002',
    date: '2024-01-08',
    items: 'Green Tea (300kg)',
    amount: 'LKR 90,000',
    status: 'Delivered'
  }, {
    id: 'PO-003',
    date: '2023-12-28',
    items: 'White Tea (200kg)',
    amount: 'LKR 150,000',
    status: 'Delivered'
  }];
  return <div className="space-y-6" data-id="element-5984">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-5985">
        <div className="flex items-center space-x-4" data-id="element-5986">
          <button onClick={() => navigate('/suppliers')} className="p-2 hover:bg-gray-100 rounded-md" data-id="element-5987">
            <ArrowLeftIcon size={20} data-id="element-5988" />
          </button>
          <div data-id="element-5989">
            <h2 className="text-2xl font-semibold text-gray-900" data-id="element-5990">
              {supplier.companyName}
            </h2>
            <p className="text-sm text-gray-500 mt-1" data-id="element-5991">Supplier Details</p>
          </div>
        </div>
        <button onClick={() => navigate(`/supplier-form?id=${id}`)} className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700" data-id="element-5992">
          <EditIcon size={18} className="mr-2" data-id="element-5993" />
          Edit Supplier
        </button>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-5994">
        {/* Left Column - Supplier Info */}
        <div className="lg:col-span-2 space-y-6" data-id="element-5995">
          {/* Contact Information */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-5996">
            <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-5997">
              Contact Information
            </h3>
            <div className="space-y-4" data-id="element-5998">
              <div className="flex items-start" data-id="element-5999">
                <MailIcon size={18} className="text-gray-400 mt-1 mr-3" data-id="element-6000" />
                <div data-id="element-6001">
                  <p className="text-sm text-gray-500" data-id="element-6002">Email</p>
                  <p className="text-sm font-medium text-gray-900" data-id="element-6003">
                    {supplier.email}
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-6004">
                <PhoneIcon size={18} className="text-gray-400 mt-1 mr-3" data-id="element-6005" />
                <div data-id="element-6006">
                  <p className="text-sm text-gray-500" data-id="element-6007">Phone</p>
                  <p className="text-sm font-medium text-gray-900" data-id="element-6008">
                    {supplier.phone}
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-6009">
                <MapPinIcon size={18} className="text-gray-400 mt-1 mr-3" data-id="element-6010" />
                <div data-id="element-6011">
                  <p className="text-sm text-gray-500" data-id="element-6012">Address</p>
                  <p className="text-sm font-medium text-gray-900" data-id="element-6013">
                    {supplier.address}
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-6014">
                <PackageIcon size={18} className="text-gray-400 mt-1 mr-3" data-id="element-6015" />
                <div data-id="element-6016">
                  <p className="text-sm text-gray-500" data-id="element-6017">Products Supplied</p>
                  <p className="text-sm font-medium text-gray-900" data-id="element-6018">
                    {supplier.productsSupplied}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Recent Orders */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-6019">
            <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-6020">
              Recent Orders
            </h3>
            <div className="space-y-3" data-id="element-6021">
              {recentOrders.map(order => <div key={order.id} className="flex items-center justify-between p-4 border border-gray-200 rounded-md hover:bg-gray-50" data-id="element-6022">
                  <div className="flex-1" data-id="element-6023">
                    <div className="flex items-center space-x-3" data-id="element-6024">
                      <p className="text-sm font-medium text-gray-900" data-id="element-6025">
                        {order.id}
                      </p>
                      <span className={`px-2 py-1 text-xs font-semibold rounded-full ${order.status === 'Delivered' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-6026">
                        {order.status}
                      </span>
                    </div>
                    <p className="text-sm text-gray-500 mt-1" data-id="element-6027">{order.items}</p>
                    <p className="text-xs text-gray-400 mt-1" data-id="element-6028">{order.date}</p>
                  </div>
                  <p className="text-sm font-medium text-gray-900" data-id="element-6029">
                    {order.amount}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
        {/* Right Column - Stats */}
        <div className="space-y-6" data-id="element-6030">
          {/* Status */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-6031">
            <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-6032">Status</h3>
            <span className={`px-3 py-1 inline-flex text-sm font-semibold rounded-full ${supplier.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-6033">
              {supplier.status}
            </span>
          </div>
          {/* Statistics */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-6034">
            <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-6035">
              Statistics
            </h3>
            <div className="space-y-4" data-id="element-6036">
              <div data-id="element-6037">
                <div className="flex items-center text-gray-500 text-sm mb-1" data-id="element-6038">
                  <TrendingUpIcon size={16} className="mr-2" data-id="element-6039" />
                  Total Orders
                </div>
                <p className="text-2xl font-semibold text-gray-900" data-id="element-6040">
                  {supplier.totalOrders}
                </p>
              </div>
              <div data-id="element-6041">
                <div className="flex items-center text-gray-500 text-sm mb-1" data-id="element-6042">
                  <TrendingUpIcon size={16} className="mr-2" data-id="element-6043" />
                  Total Value
                </div>
                <p className="text-2xl font-semibold text-gray-900" data-id="element-6044">
                  {supplier.totalValue}
                </p>
              </div>
              <div data-id="element-6045">
                <div className="flex items-center text-gray-500 text-sm mb-1" data-id="element-6046">
                  <CalendarIcon size={16} className="mr-2" data-id="element-6047" />
                  Last Order
                </div>
                <p className="text-sm font-medium text-gray-900" data-id="element-6048">
                  {supplier.lastOrderDate}
                </p>
              </div>
              <div data-id="element-6049">
                <div className="flex items-center text-gray-500 text-sm mb-1" data-id="element-6050">
                  <CalendarIcon size={16} className="mr-2" data-id="element-6051" />
                  Member Since
                </div>
                <p className="text-sm font-medium text-gray-900" data-id="element-6052">
                  {supplier.createdDate}
                </p>
              </div>
            </div>
          </div>
          {/* Payment Terms */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-6053">
            <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-6054">
              Payment Terms
            </h3>
            <p className="text-sm text-gray-900" data-id="element-6055">{supplier.paymentTerms}</p>
          </div>
        </div>
      </div>
    </div>;
}